import { type ComponentProps } from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';

import { pointerEventsStyles, theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const FadeGradient = (props: Props) => {
  const { reverse, style } = props;

  const colors = reverse ? COLORS_REVERSE : COLORS_DEFAULT;

  return (
    <Animated.View style={[styles.gradient, style, pointerEventsStyles.none]}>
      <LinearGradient
        colors={colors}
        end={GRADIENT_END}
        start={GRADIENT_START}
        style={StyleSheet.absoluteFill}
      />
    </Animated.View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  gradient: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: 80,
    borderRadius: theme.radius['3xLarge'],
    overflow: 'hidden',
    zIndex: 1,
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const COLOR_WHITE_OPAQUE = theme.colors.WHITE;
const COLOR_WHITE_TRANSPARENT = theme.colors.OPACITY.WHITE.TRANSPARENT;

const COLORS_DEFAULT = [COLOR_WHITE_OPAQUE, COLOR_WHITE_TRANSPARENT] as const;
const COLORS_REVERSE = [COLOR_WHITE_TRANSPARENT, COLOR_WHITE_OPAQUE] as const;

const GRADIENT_START = { x: 0, y: 0 };
const GRADIENT_END = { x: 1, y: 0 };

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  reverse?: boolean;
  style?: ComponentProps<typeof Animated.View>['style'];
};
